<template>
  <div class="directory-switcher">
    <button
      class="tgb-btn-group tgb-text-right"
      role="group"
      aria-label="Productions Directory View Switch"
      title="Toggle list view"
      data-entity="producer-dashboard-toggleDirectoryView"
      @click="toggleView"
    >
      <div
        type="button"
        class="directory-switcher__option"
        aria-label="card view"
        :class="{ 'directory-switcher__option--active': view == 'directory-grid' }"
      >
        <span class="fas fa-th-large directory-switcher__icon" />
      </div>

      <div
        type="button"
        class="directory-switcher__option"
        aria-label="table view"
        :class="{ 'directory-switcher__option--active': view == 'directory-table' }"
      >
        <span class="fas fa-bars directory-switcher__icon" />
      </div>
    </button>
  </div>
</template>

<script>
export default {
  name: "DirectorySwitcher",
  props: {
    view: {
      type: String,
    },
  },

  methods: {
    toggleView() {
      if (this.view === 'directory-table') {
        this.$emit('update:view', 'tgb-directory-grid');
      } else {
        this.$emit('update:view', 'tgb-directory-table');
      }
    },
  },
};
</script>

<style lang="scss">
.directory-switcher {
  display: flex;
  justify-content: flex-end;
  flex-grow: 1;

  > button {
    outline: none;
    border: 0;
    background: transparent;
    padding: 0;
    display: flex;
    align-items: center;
    gap: 0;
  }
}

.directory-switcher__option {
  background-color: transparent;
  width: 30px;
  height: 28px;
  color: white;
  align-items: center;
  justify-content: center;
  display: flex;

  &--active {
    color: #23cdf4;
  }

  .directory-switcher__icon::before {
    font-size: 16px;
  }
}
</style>
